import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import { TextField } from '../../../../../../../../../components/TextField';
import { PlainRenderInputElement } from './PlainRenderInputElement';

// Context
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';
import { useDebouncedStringCallback } from '../../../../../../hooks/useDebouncedStringCallback';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const NumbericInputContainer = styled.div`
    max-width: 8rem;
`;

const NUMERIC_INPUT_PLACEHOLDER = 'numeric value';

export const NumericInput = ({ id, predicateType, plainrender = true, ...props }) => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();
    const [numericValue, setNumericValue] = useDebouncedStringCallback({
        startVal: part?.dataInputNumeric,
        debounceCallback: (newVal) => {
            setEdited(true);
            updatePredicateElement({
                ...part,
                dtoState: dtoState.Updated,
                dataInputNumeric: newVal
            });
        }
    });

    if (plainrender) {
        return (
            <PlainRenderInputElement
                value={numericValue}
                placeholderPartial={NUMERIC_INPUT_PLACEHOLDER}
                overridable={part?.overridable}
            />
        );
    }
    return (
        <NumbericInputContainer>
            <TextField
                withBorder
                type={'number'}
                step={'1'}
                size={'xs'}
                id={`part_numeric_input_${id}`}
                name={`part_numeric_input_${id}`}
                value={numericValue}
                onInput={(e) => {
                    setNumericValue(e.target.value);
                }}
                style={{
                    width: '100%'
                }}
                placeholder={'Enter numeric value'}
            />
        </NumbericInputContainer>
    );
};

export default NumericInput;

NumericInput.propTypes = {
    ...ruleEditorViewPartCommonProps
};
